<div class="container">
  <div class="row">
    <div class="col-md-8 ms-auto me-auto">
      <h2 class="title">{{'reserves.myWallet'|traduccion}}</h2>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="card">
        <div class="card-header">
          <div class="float-left"></div>
          <div class="float-right"></div>
        </div>
        <div class="card-body">


          <mat-card appearance="outlined" class="invoicing-card">

            <div class="header-grid">
              <div class="header-item">
                <h4>{{'myWallet.balance.title'|traduccion}}</h4>
                <p class="amount">{{wallet.balance|currency: 'EUR'}}</p>
                <small class="info"><mat-icon>info</mat-icon> {{'myWallet.balance.info'|traduccion}}</small>
              </div>

              <div class="header-item">
                <h4>{{'myWallet.lastPurchase.title'|traduccion}}</h4>
                <p class="amount">{{ (wallet.lastMovement?.amount || 0)|currency: 'EUR'}}</p>
                <p>{{$safeNavigationMigration(wallet.lastMovement?.description)|traduccion}}</p>
              </div>

              <div class="header-item enquiries">
                <h4>{{'myWallet.movements.title'|traduccion}}</h4>
                <button mat-raised-button color="primary" (click)="openInvoiceDialog()">
                  {{'myWallet.movements.button'|traduccion}}
                </button>
              </div>
            </div>


          </mat-card>

          <h2>{{'myWallet.coupons.buy'|traduccion}}</h2>
          @if ((coupons | keyvalue).length > 0) {
            @for (couponKeyValue of coupons | keyvalue; track couponKeyValue) {
              <div class="coupon-location-group">
                <h3 class="coupon-location-title">{{couponKeyValue.key}}</h3>
                <div class="coupons-grid">
                  @for (coupon of couponKeyValue.value; track coupon) {
                    <mat-card appearance="outlined" class="coupon-card">
                      <mat-card-header>
                        <mat-card-title>{{coupon.description}}</mat-card-title>
                      </mat-card-header>
                      <mat-card-content>
                        <p class="price">{{ coupon.price | currency:'EUR' }}</p>
                      </mat-card-content>
                      <mat-card-actions>
                        <button mat-raised-button color="primary" (click)="buyMyDiscountCoupon(coupon)">{{'myWallet.coupons.exchange'|traduccion}}</button>
                      </mat-card-actions>
                    </mat-card>
                  }
                </div>
              </div>
            }
          } @else {
            <div class="no-data">
              {{'myWallet.coupons.noData'|traduccion}}
            </div>
          }


          <h2>{{'myWallet.discount.myDiscounts'|traduccion}}</h2>
          <div class="coupons-grid discounts">
            @for (discount of discounts; track discount) {
              <mat-card appearance="outlined" class="coupon-card" [class.disabled]="discount.disabled">
                <mat-card-header>
                  <mat-card-title>{{'myWallet.discount.code'|traduccion}}: {{ discount.code }}</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p>{{showDescriptionCoupons(discount.description)}}</p>
                  @if (discount.discountType=='AMOUNT') {
                    <p class="price">-{{ discount.discount|currency:'EUR' }}</p>
                  }
                  @if (discount.discountType=='PERCENTAGE') {
                    <p class="price">-{{ discount.discount }}%</p>
                  }
                  <p>{{discount.location.name}}</p>
                  <small class="info"><mat-icon>info</mat-icon> {{'myWallet.discount.info'|traduccion}}</small>
                </mat-card-content>
              </mat-card>
            }
            <!-- Mensaje sin datos -->
            @if (discounts.length === 0) {
              <div class="no-data">
                {{'myWallet.discount.noData'|traduccion}}
              </div>
            }
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
